import { useContext, useEffect, useState } from "react";
import apiRequest from "../../../../services/apiRequest";
import AuthenticationService from "../../../../services/AuthenticationService";
import { NotificationsContext } from "../../../Notifications";

const useRoleTypes = () => {
  const [userScopes] = useState(AuthenticationService.getUserScopes());
  const [roleTypes, setRoleTypes] = useState(null);
  const { push } = useContext(NotificationsContext);

  useEffect(() => {
    let closed = false;
    const fetchRoleTypes = async () => {
      try {
        const data = await apiRequest.get("/roles");

        if (typeof data !== "object") {
          throw new Error("not object");
        }

        if (!closed) {
          setRoleTypes(data);
        }
      } catch (error) {
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

    if (roleTypes === null) {
      if (userScopes.indexOf("role:read") >= 0) {
        fetchRoleTypes();
      } else {
        setRoleTypes(false);
        push({
          title: "Scope role:read non trovato",
          type: "error",
          fixed: true,
        });
      }
    }

    return () => {
      closed = true;
    };
  }, [userScopes, roleTypes, push]);

  return roleTypes;
};

export default useRoleTypes;
